import { render, staticRenderFns } from "./UpdateDocumentItemPage.vue?vue&type=template&id=8c967f4e&scoped=true&"
import script from "./UpdateDocumentItemPage.vue?vue&type=script&lang=js&"
export * from "./UpdateDocumentItemPage.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDocumentItemPage.vue?vue&type=style&index=0&id=8c967f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c967f4e",
  null
  
)

export default component.exports